import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {observer,inject} from 'mobx-react';

import './index.scss';
import Grid from 'material-ui/Grid';
import Divider from 'material-ui/Divider';
import Button from 'material-ui/Button';
import {backButton, stepButton} from "../../constants/theme";
import { Link } from 'react-router-dom'

@inject("projectDataStore")
@observer
class ModalStep extends Component {

    constructor(props) {
        super(props);
        this.state = {
            history: this.props.history,
            value: 0
        }
    }

    nextStep(path) {
        const { projectIdSelected, planIdSelected } = this.props.projectDataStore;
        switch (path) {
            case 'summary':
                path = path + '/' + projectIdSelected + '/' + (planIdSelected || '');
                break;
            case 'back':
                this.props.projectDataStore.setType('project');
                path = 'wizard';
                break;
            case 'next':
                this.props.projectDataStore.getPlan();
                this.props.projectDataStore.setType('plan');
                path = 'wizard/'+projectIdSelected;
                break;
            default:
        }
        this.state.history.push('/'+path);
    }

    render() {
        // Render nothing if the "show" prop is false
        if(!this.props.show) {
            return null;
        }

        // The gray background
        const backdropStyle = {
            // position: 'fixed',
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: 'rgba(0,0,0,0.3)',
            backgroundImage : 'url("assets/wizard_bg.png")',
            padding: 50
        };

        // The modal "window"
        const modalStyle = {
            top: 0,
            bottom: 0,
            backgroundColor: '#fff',
            borderRadius: 5,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
        };

        const { type, subType } = this.props.projectDataStore;

        return (
            <div className="backdrop" style={backdropStyle}>
                <div className="modal">
                    <div style={modalStyle}>
                        <div className='header'>
                            <Grid container className='layout' spacing={0}>
                                <Grid item xs={12} sm={4} md={3} lg={2}>
                                    <Link to="/landing">
                                        <img src='assets/logo.png' alt='logo' className='logoHeader' />
                                    </Link>
                                </Grid>
                                <Grid item xs={12} sm={8} md={9} lg={10}>
                                    <span className='headerModal'> { type === 'project' ? 'กรุณาเลือกโครงการ' : 'กรุณาเลือกแปลนบ้าน'  } </span>
                                </Grid>
                            </Grid>
                        </div>
                        <Divider light />

                        {this.props.children}

                        <div className="footerModal">
                            <Divider />
                            <Grid container className='layout' spacing={0}>
                                <Grid item xs={12} sm={12} md={12}>
                                    { type === 'plan' ?
                                        <Button raised
                                                style={backButton}
                                                className='rightButton'
                                                onClick={() => this.nextStep('back')}
                                        > ย้อนกลับ </Button>
                                        : null
                                    }
                                    { type === 'project' && (subType === 'บ้านเดี่ยว' || subType === 'บ้านแฝด') ?
                                        <Button raised
                                                style={stepButton}
                                                className='rightButton'
                                                onClick={() => this.nextStep('next')} > ถัดไป </Button>
                                        :
                                        <Button raised
                                                style={stepButton}
                                                className='rightButton'
                                                onClick={() => this.nextStep('summary')}> ดูผลการติดตั้ง </Button>
                                    }
                                </Grid>
                            </Grid>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ModalStep.propTypes = {
    // onClose: PropTypes.func.isRequired,
    show: PropTypes.bool,
    children: PropTypes.node
};

export default ModalStep;


// WEBPACK FOOTER //
// ./src/components/modalStep/index.js